import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isAudioBufferSourceNode } from '../guards/audio-buffer-source-node';
import { isAudioWorkletNode } from '../guards/audio-worklet-node';
import { isBiquadFilterNode } from '../guards/biquad-filter-node';
import { isConstantSourceNode } from '../guards/constant-source-node';
import { isGainNode } from '../guards/gain-node';
import { isOscillatorNode } from '../guards/oscillator-node';
import { isStereoPannerNode } from '../guards/stereo-panner-node';
import { getAudioNodeConnections } from './get-audio-node-connections';
import { getAudioParamConnections } from './get-audio-param-connections';
import { isActiveAudioNode } from './is-active-audio-node';
import { setInternalStateToPassive } from './set-internal-state-to-passive';
export var deactivateActiveAudioNodeInputConnections = function deactivateActiveAudioNodeInputConnections(audioNode, trace) {
  var _getAudioNodeConnecti = getAudioNodeConnections(audioNode),
    activeInputs = _getAudioNodeConnecti.activeInputs;
  activeInputs.forEach(function (connections) {
    return connections.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        source = _ref2[0];
      if (!trace.includes(audioNode)) {
        deactivateActiveAudioNodeInputConnections(source, [].concat(_toConsumableArray(trace), [audioNode]));
      }
    });
  });
  var audioParams = isAudioBufferSourceNode(audioNode) ? [
  // Bug #149: Safari does not yet support the detune AudioParam.
  audioNode.playbackRate] : isAudioWorkletNode(audioNode) ? Array.from(audioNode.parameters.values()) : isBiquadFilterNode(audioNode) ? [audioNode.Q, audioNode.detune, audioNode.frequency, audioNode.gain] : isConstantSourceNode(audioNode) ? [audioNode.offset] : isGainNode(audioNode) ? [audioNode.gain] : isOscillatorNode(audioNode) ? [audioNode.detune, audioNode.frequency] : isStereoPannerNode(audioNode) ? [audioNode.pan] : [];
  var _iterator = _createForOfIteratorHelper(audioParams),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var audioParam = _step.value;
      var audioParamConnections = getAudioParamConnections(audioParam);
      if (audioParamConnections !== undefined) {
        audioParamConnections.activeInputs.forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
            source = _ref4[0];
          return deactivateActiveAudioNodeInputConnections(source, trace);
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (isActiveAudioNode(audioNode)) {
    setInternalStateToPassive(audioNode);
  }
};